import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const TickerTapeIcon = ({ color = '#1A2E34', size = 24, ...props }) => (
  <svg
    viewBox="0 0 48 48"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41.295 0A6.713 6.713 0 0 1 48 6.705v34.59A6.713 6.713 0 0 1 41.295 48H6.705A6.713 6.713 0 0 1 0 41.295V6.705A6.713 6.713 0 0 1 6.705 0zm0 3H6.705a3.707 3.707 0 0 0-3.633 3H3v36h.072a3.706 3.706 0 0 0 3.633 3h34.59a3.707 3.707 0 0 0 3.627-3H45V6h-.072a3.706 3.706 0 0 0-3.633-3zM35.07 30A4.9 4.9 0 0 1 40 35c0 2.66-2.097 4.88-4.759 4.995l-.217.005H12.975C10.257 40 8 37.778 8 35s2.303-5 5.021-5 4.975 2.222 4.975 5a4.95 4.95 0 0 1-.87 2.813l-.143.196h14.126A4.934 4.934 0 0 1 30.095 35c0-2.731 2.212-5 4.975-5zm-22.095 2.083A2.897 2.897 0 0 0 10.073 35c0 1.62 1.29 2.917 2.902 2.917S15.923 36.62 15.877 35c0-1.62-1.29-2.917-2.902-2.917zm22.104 0A2.897 2.897 0 0 0 32.177 35c0 1.62 1.29 2.917 2.902 2.917A2.897 2.897 0 0 0 37.981 35c0-1.62-1.29-2.917-2.902-2.917zM30.75 8c.647 0 1.18.492 1.244 1.122L32 9.25v3a1.25 1.25 0 0 1-2.494.128l-.006-.128V10.5h-4.75v14h.833a1.25 1.25 0 0 1 .128 2.494l-.128.006h-4.166a1.25 1.25 0 0 1-.128-2.494l.128-.006h.833v-14H17.5v1.75a1.25 1.25 0 0 1-2.494.128L15 12.25v-3c0-.647.492-1.18 1.122-1.244L16.25 8h14.5z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

TickerTapeIcon.propTypes = propTypes;

export default TickerTapeIcon;
